// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit {
  display: none;
}
.notShow {
  display: none;
}
.card {
  max-width: 330px;
  min-height: 340px;
}
.textInput {
  background-color: transparent;
  border: 0;
}
.card-text {
  display: flex;
  width: 100% !important;
}
.left,
.right {
  width: 100%;
}
.left {
  float: left;
  margin-left: 5%;
}
.right {
  display: flex;
  float: right;
  margin-left: 40%;
}
.btn {
  float: right;
  margin-left: 5%;
  color: #b7b7b7;
}
.notShowInput {
  display: none;
}
.showInput {
  display: flex;
  width: 100%;
  text-align: center;
}
.input-search {
  margin-right: 5px;
}
.newAdd {
  background-color: transparent;
  border: 0;
}
.tagScenario {
  border: 0;
  font-size: 15px;
  border-radius: 8px;
  width: 200px;
  height: 30px;
  text-align: center;
  padding-top: 3%;
}
.table-scenario {
  margin-top: 1rem;
}
.table-scenario * > td.scenario-name {
  font-weight: 700 !important;
}
.table-scenario * > td {
  font-weight: 600 !important;
}
thead > tr > .ant-table-cell {
  background-color: #FBF6FF !important;
  color: #4A309D !important;
}
.table-scenario > div > div > div > ul > .ant-pagination-total-text {
  position: absolute;
  left: 0;
}
@media screen and (max-width: 576px) {
  .input-group {
    width: 100% !important;
  }
}
.card-scroll::-webkit-scrollbar {
  background: transparent;
  /* Chrome/Safari/Webkit */
  width: 0px;
}
.card-scroll {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}
.card-scroll {
  height: 240px;
  overflow-y: scroll;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/views/settings/Scenario/styles/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEA;EACE,aAAA;AAAF;AAGA;EACE,gBAAA;EACA,iBAAA;AADF;AAIA;EACE,6BAAA;EACA,SAAA;AAFF;AAKA;EACE,aAAA;EACA,sBAAA;AAHF;AAMA;;EAEE,WAAA;AAJF;AAOA;EACE,WAAA;EACA,eAAA;AALF;AAQA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AANF;AASA;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAPF;AAUA;EACE,aAAA;AARF;AAWA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AATF;AAYA;EACE,iBAAA;AAVF;AAaA;EACE,6BAAA;EACA,SAAA;AAXF;AAcA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAZF;AAeA;EACE,gBAAA;AAbF;AAeA;EACE,2BAAA;AAbF;AAeA;EACE,2BAAA;AAbF;AAgBA;EACE,oCAAA;EACA,yBAAA;AAdF;AAgBA;EACE,kBAAA;EACA,OAAA;AAdF;AAiBA;EACE;IACE,sBAAA;EAfF;AACF;AAkBA;EACE,uBAAA;EAhBA,yBAAyB;EAiBzB,UAAA;AAfF;AAkBA;EACE,qBAAA;EAhBA,YAAY;EAiBZ,wBAAA;EAfA,WAAW;AACb;AAiBA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;AAfF","sourcesContent":[".edit {\n  display: none;\n}\n\n.notShow {\n  display: none;\n}\n\n.card {\n  max-width: 330px;\n  min-height: 340px;\n}\n\n.textInput {\n  background-color: transparent;\n  border: 0;\n}\n\n.card-text {\n  display: flex;\n  width: 100% !important;\n}\n\n.left,\n.right {\n  width: 100%;\n}\n\n.left {\n  float: left;\n  margin-left: 5%;\n}\n\n.right {\n  display: flex;\n  float: right;\n  margin-left: 40%;\n}\n\n.btn {\n  float: right;\n  margin-left: 5%;\n  color: #b7b7b7;\n}\n\n.notShowInput {\n  display: none;\n}\n\n.showInput {\n  display: flex;\n  width: 100%;\n  text-align: center;\n}\n\n.input-search{\n  margin-right: 5px;\n}\n\n.newAdd {\n  background-color: transparent;\n  border: 0;\n}\n\n.tagScenario {\n  border: 0;\n  font-size: 15px;\n  border-radius: 8px;\n  width: 200px;\n  height: 30px;\n  text-align: center;\n  padding-top: 3%;\n}\n\n.table-scenario {\n  margin-top: 1rem;\n}\n.table-scenario *>td.scenario-name{\n  font-weight: 700 !important;\n}\n.table-scenario * > td{\n  font-weight: 600 !important;\n}\n\nthead>tr>.ant-table-cell {\n  background-color: #FBF6FF !important;\n  color: #4A309D !important;\n}\n.table-scenario>div>div >div>ul>.ant-pagination-total-text{\n  position: absolute;\n  left: 0;\n}\n\n@media screen and (max-width: 576px) {\n  .input-group {\n    width: 100% !important;\n  }\n}\n\n.card-scroll::-webkit-scrollbar {\n  background: transparent; /* Chrome/Safari/Webkit */\n  width: 0px;\n}\n    \n.card-scroll {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none;  /* IE 10+ */\n}\n\n.card-scroll{\n  height: 240px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
